export default {"src":"/_next/static/media/check-extra-thin.2e9cc810.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};